/**------------- Menu Big constants -------------**/

/*  General  */
export const MENU_BIG_CONTAINER_CLASS_NAME =
	"menu-container-big";
